import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface SignUpService {
  name: string;
  api_token: string;
}

export interface SignUpServiceInfo {
  errors: unknown;
  listSignUpService: SignUpService;
  isAuthenticated: boolean;
}

@Module
export default class SignUpServiceModule
  extends VuexModule
  implements SignUpServiceInfo
{
  errors = {};
  listSignUpService = {} as SignUpService;
  signUpRegisterDetail = {};
  isAuthenticated = !!JwtService.getToken();

  get getListSignUpService() {
    return this.listSignUpService;
  }

  get getSignUpServiceDetail() {
    return this.signUpRegisterDetail;
  }

  @Mutation
  [Mutations.SIGNUP_SERVICE_LIST_DATA](listSignUpService) {
    this.listSignUpService = listSignUpService;
  }

  @Mutation
  [Mutations.SIGNUP_SERVICE_DETAIL_DATA](signUpRegisterDetail) {
    this.signUpRegisterDetail = signUpRegisterDetail;
  }

  @Action
  [Actions.SIGNUP_SERVICE_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/register_statistical_services", payload)
        .then((data) => {
          this.context.commit(Mutations.SIGNUP_SERVICE_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.SIGNUP_SERVICE_DETAIL](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(
        `/register_statistical_services/${payload.id}/detail`
      )
        .then((data) => {
          this.context.commit(Mutations.SIGNUP_SERVICE_DETAIL_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.SIGNUP_SERVICE_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(
        `register_statistical_services/${payload.id}/delete`,
        payload
      )
        .then((res) => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.SIGNUP_SERVICE_UPSERT](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      const idPath = payload.get("id") ? `/${payload.get("id")}` : "";
      return ApiService.post(
        `register_statistical_services/upsert${idPath}`,
        payload
      )
        .then(() => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }

  @Action
  [Actions.SIGNUP_SERVICE_CHANGE_STATUS](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(
        `/register_statistical_services/${payload.id}/update-status`,
        payload
      )
        .then(() => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    }
  }
}
